import { ButtonWithLoadingState } from 'components/curo-components/common/Button';
import { ModalContentWrapper, ModalOverlay } from 'components/curo-components/common/Modal';
import ModalButtonsWrapper from 'components/curo-components/common/ModalButtonsWrapper';
import Title from 'components/curo-components/common/Title';
import Typography from 'components/curo-components/common/Typography';

import styles from './ConfirmationModal.module.scss';

interface IConfirmationModalProps {
  onClose: () => void;
  handleAccept: () => Promise<unknown>;
  handleDecline: () => Promise<unknown>;
  title: string;
  description: string;
  confirmButtonTitle: string;
  declineButtonTitle: string;
}

const ConfirmationModal = ({
  onClose,
  handleAccept,
  handleDecline,
  title,
  description,
  confirmButtonTitle,
  declineButtonTitle,
}: IConfirmationModalProps) => {
  return (
    <ModalOverlay onClose={onClose}>
      <ModalContentWrapper onClose={onClose} wrapperClassName={styles.modalContentWrapper}>
        <Title type="h3" className={styles.title}>
          {title}
        </Title>
        <Typography type="primary" weight="normal" className={styles.text}>
          {description}
        </Typography>
        <ModalButtonsWrapper position="flex-start">
          <ButtonWithLoadingState kind="primary" size="form" onClick={handleAccept}>
            {confirmButtonTitle}
          </ButtonWithLoadingState>
          <ButtonWithLoadingState kind="secondary" size="form" onClick={handleDecline}>
            {declineButtonTitle}
          </ButtonWithLoadingState>
        </ModalButtonsWrapper>
      </ModalContentWrapper>
    </ModalOverlay>
  );
};

export default ConfirmationModal;
